import { render } from "./VideoGames.vue?vue&type=template&id=4ffb1072"
import script from "./VideoGames.vue?vue&type=script&lang=js"
export * from "./VideoGames.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__